import appAxios from "services/axios";
class UsersService {
  me = async () => {
    return await appAxios.get("/user");
  };
}

export default new UsersService();
